import '@loyal_template/loading.css'
import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import yn from 'yn'

import OnDemandLiveRegion from 'on-demand-live-region'

const Splash = ({ text }) => {
  setTimeout(function () {
    const liveRegionDelayed = new OnDemandLiveRegion({
      delay: 300,
      level: 'assertive',
      parent: '#loadingscreen'
    })
    document.querySelectorAll('#loadingscreen').length > 0 && liveRegionDelayed.say(`${yn(process.env.REACT_APP_HAS_CUSTOM_SPLASH) ? process.env.REACT_APP_HAS_CUSTOM_SPLASH_TEXT : text}`)
  }, 1000)
  return (
    <div data-campaign={process.env.REACT_APP_CATALOG_ID}>
      <div id='loadingscreen' className='row loading-screen screen-default'>
        <div className='col-12 bg-brand-4 progress-loader p-0'>
          <div className='progress-bar' />
        </div>
        <div className='col-12 bg-brand-2 txt-loading py-5 d-flex align-items-center justify-content-center'>
          <div>
            <div id='logo'>
              <div className='mr-auto ml-auto txt-center logo-header'>
                <Link to='/' tabIndex={0} title={text}>
                  <span className='hide-absolute'>{process.env.REACT_APP_TITLE || 'Web Prêmios'}</span>
                </Link>
              </div>
            </div>
            <p className='color-ui-white txt-normal mx-auto my-2'>{text}</p>
            <div className='btn-loading loader-screen mx-auto' />
          </div>
        </div>
      </div>
    </div>
  )
}

Splash.propTypes = {
  text: PropTypes.string.isRequired
}

export default Splash



// WEBPACK FOOTER //
// ./src/App/Splash.js